export type FaqGroupSlug = 'bokning' | 'leverans' | 'betalning' | 'utrustning' | 'scen' | 'ovrigt';

export const FAQ_GROUPS: { slug: FaqGroupSlug; label: string }[] = [
  { slug: 'bokning', label: 'Bokning & tider' },
  { slug: 'leverans', label: 'Leverans & hämtning' },
  { slug: 'betalning', label: 'Betalning & avbokning' },
  { slug: 'utrustning', label: 'Utrustning & ansvar' },
  { slug: 'scen', label: 'Scen, tross & offert' },
  { slug: 'ovrigt', label: 'Övrigt' },
];

export const FAQ_GROUP_SLUGS = FAQ_GROUPS.map((g) => g.slug);

const labelBySlug = Object.fromEntries(FAQ_GROUPS.map((g) => [g.slug, g.label])) as Record<
  FaqGroupSlug,
  string
>;

export function normalizeFaqGroup(raw: string | null | undefined): FaqGroupSlug {
  if (raw && FAQ_GROUP_SLUGS.includes(raw as FaqGroupSlug)) {
    return raw as FaqGroupSlug;
  }
  return 'ovrigt';
}

export function getFaqGroupLabel(slug: string | null | undefined): string {
  return labelBySlug[normalizeFaqGroup(slug)];
}

export function sortFaqGroupsByConfig(slugs: FaqGroupSlug[]): FaqGroupSlug[] {
  const order = new Map(FAQ_GROUP_SLUGS.map((slug, index) => [slug, index]));
  return [...slugs].sort((a, b) => (order.get(a) ?? 99) - (order.get(b) ?? 99));
}
